export default async function deleteUser(accessToken: string): Promise<void> {
  const fetchUrl = `${process.env.REACT_APP_SSO_API_URL}/api/v1/cognito/soft_delete_user?${process.env.REACT_APP_SSO_API_PARAMS}`;
  try {
    const response = await fetch(fetchUrl, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }).then((data) =>  {
      console.log(data);
    });
    console.log(response);
  } catch (error) {
    console.log('Error disabling user', error);
  }
}